<template>
  <q-layout view="hHh Lpr lff">

    <!-- (Optional) The Header -->
    <q-header>
      <q-toolbar>
        <q-toolbar-title>
          Submind
          <span slot="subtitle">+Docs</span>
        </q-toolbar-title>
        <q-btn
          flat
          dense
          round
          @click="rightDrawerOpen = !rightDrawerOpen"
          aria-label="Menu"
          v-if="currentUser">
          <q-icon name="mdi-settings" />
        </q-btn>
      </q-toolbar>
    </q-header>

    <q-drawer
      no-hide-on-route-change
      v-model="leftDrawer"
      :content-class="($q.theme === 'mat' ? 'bg-grey-1' : null) + ' ' + 'no-shadow'"
      :content-style="{'border-right': 'lightgrey solid 1px'}"
    >
      <div>
        <div style="padding-left: 5px; padding-right: 5px;">
          <q-input v-model="filter" float-label="Search" style="margin-bottom: 5px; padding-bottom: 2px;"></q-input>
          <q-tree
            :nodes="items"
            node-key="page"
            :filter="filter"
            :selected.sync="selectedPage" />
        </div>
      </div>
    </q-drawer>

    <q-drawer
      side="right"
      v-model="rightDrawerOpen"
      overlay
      :no-swipe-open="!$q.platform.is.mobile"
      :no-swipe-close="!$q.platform.is.mobile"
      :content-class="$q.theme === 'mat' ? 'bg-grey-2' : null"
      behavior="mobile"
      v-if="currentUser">

      <q-card square class="q-pt-sm shadow-2">
        <q-item>
          <q-item-section side :avatar="currentUser.photoURL || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRfNLrA4MhND_BlfRAqE2gustOyW74DWoHQx-4ygBAQdgoI0VBrlg'"></q-item-section>
          <q-item-main>
            <q-item-tile label>{{currentUser.displayName}}</q-item-tile>
            <q-item-tile sublabel>{{firebaseUser.email}}</q-item-tile>
          </q-item-main>
        </q-item>
      </q-card>

      <q-list
        no-border
        link
        inset-delimiter >
        <q-item @click.native="$router.push('/components')">
          <q-item-section side icon="code" />
          <q-item-main label="Components" />
        </q-item>
        <q-item @click.native="$router.push('/noteTemplates')">
          <q-item-section side icon="extension" />
          <q-item-main label="Note Templates" />
        </q-item>
        <q-item @click.native="showSettings">
          <q-item-section side icon="tune" />
          <q-item-main label="All Settings" />
        </q-item>
        <q-item @click.native="$router.push('/docs/home')">
          <q-item-section side icon="bookmark" />
          <q-item-main label="Documentation" />
        </q-item>
        <q-item @click.native="askLogout">
          <q-item-section side icon="exit to app" />
          <q-item-main label="Log Out" />
        </q-item>
      </q-list>
    </q-drawer>

    <q-page-container>
      <!-- This is where pages get injected -->
      <q-scroll-area class="allow-touch col" style="height: 100vh; width: 100%;">
        <router-view />
      </q-scroll-area>
    </q-page-container>

  </q-layout>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data () {
    return {
      filter: '',
      leftDrawer: true,
      rightDrawerOpen: false,
      selectedPage: null,
      items: [
        {
          label: 'Home',
          page: 'home'
        },
        {
          label: 'Interface',
          page: 'interface'
        },
        {
          label: 'Notes',
          page: 'notes'
        },
        {
          label: 'Components',
          page: 'components',
          children: [
            {
              label: 'This Component $tc',
              page: '../components/this-component'
            },
            {
              label: 'Component Helper $ch',
              page: '../componets/component-helper'
            }
          ]
        },
        {
          label: 'Note Templates',
          page: 'note-templates'
        },
        {
          label: 'Public Notes',
          page: 'public-notes'
        },
        {
          label: 'The Tech Driving Submind',
          page: 'tech'
        }]
    }
  },
  watch: {
    selectedPage (newVal) {
      this.selectedPage = newVal
      this.$router.push('/docs/' + newVal)
    }
  },
  computed: {
    currentUser () { return this.$store.state.auth.currentUser },
    firebaseUser () { return firebase.auth().currentUser }
  },
  methods: {
  },
  mounted () {
    if (!this.selectedPage) {
      this.selectedPage = 'home'
    }
  }
  // beforeRouteEnter (to, from, next) {
  //
  // }
}
</script>

<style>
</style>
